export function Logo({ className = "" }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Exec9"
      className={`logo-mark inline-block ${className}`}
      style={{
        maskImage: "url(/logo.svg)",
        WebkitMaskImage: "url(/logo.svg)",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
